// extracted by mini-css-extract-plugin
export var sliderRange = "_ov-2";
export var sliderRoot = "_ov-0";
export var sliderThumb = "_ov-3";
export var sliderTrack = "_ov-1";